var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1365 0.434814H6.10616C5.725 0.434814 5.41602 0.743802 5.41602 1.12496V6.12849C5.41602 6.50965 5.725 6.81864 6.10616 6.81864H53.1365C53.5177 6.81864 53.8267 6.50965 53.8267 6.12849V1.12496C53.8267 0.743802 53.5177 0.434814 53.1365 0.434814Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8281 6.8042V11.0169L23.0013 17.6308",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 6.8042V11.0169L36.6602 17.6308",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1738 6.8042V24.7335",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2168 24.5166H39.1461",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33603 48.3847C3.08515 49.4199 1.35979 49.3912 0.497115 48.3272C-0.379942 47.2632 -0.0636258 45.581 1.18726 44.5458C2.43814 43.5106 6.9672 41.2245 7.82988 42.2885C8.70694 43.3524 5.58692 47.3495 4.33603 48.3703V48.3847Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4908 39.197C32.4045 40.8073 31.2256 42.0582 29.8453 41.9863C28.4794 41.9145 27.4441 40.5342 27.5304 38.9238C27.6167 37.3135 28.997 32.425 30.3629 32.4969C31.7288 32.5688 32.5627 37.5723 32.4764 39.197H32.4908Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4908 53.5312C32.4045 55.1416 31.2256 56.3925 29.8453 56.3206C28.4794 56.2487 27.4441 54.8684 27.5304 53.2581C27.6167 51.6477 28.997 46.7592 30.3629 46.8311C31.7288 46.903 32.5627 51.9065 32.4764 53.5312H32.4908Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4413 52.9859C17.8374 54.4956 16.3278 55.3008 15.0481 54.7975C13.7685 54.2943 13.2221 52.6552 13.826 51.1599C14.4299 49.6502 17.2767 45.4662 18.5563 45.9695C19.836 46.4727 19.0308 51.4762 18.4413 52.9859Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4094 51.504C46.9845 53.0137 46.4094 54.6384 45.1441 55.1272C43.8645 55.6161 42.3548 54.7965 41.7797 53.2725C41.2045 51.7628 40.4569 46.7449 41.7365 46.256C43.0162 45.7672 45.8199 49.9799 46.4094 51.504Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5665 38.0466C16.3156 39.0818 14.5903 39.053 13.7276 37.9891C12.8505 36.9251 13.1668 35.2429 14.4177 34.2077C15.6686 33.1725 20.1977 30.8864 21.0604 31.9503C21.9374 33.0143 18.8174 37.0114 17.5665 38.0322V38.0466Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7725 44.8616C60.0378 45.8681 60.3828 47.5503 59.5345 48.6286C58.6862 49.707 56.9609 49.7645 55.6956 48.758C54.4304 47.7516 51.2385 43.812 52.0868 42.7337C52.9351 41.6553 57.5073 43.8552 58.7725 44.8616Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.876 34.1072C47.1413 35.1137 47.4864 36.7959 46.6381 37.8742C45.7898 38.9526 44.0644 39.0101 42.7991 38.0036C41.5339 36.9972 38.342 33.0576 39.1903 31.9793C40.0386 30.9009 44.6108 33.1008 45.876 34.1072Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklers);
export default __webpack_public_path__ + "static/media/sprinklers.c188630d.svg";
export { ForwardRef as ReactComponent };